/* Built In Imports */
import { Radio, RadioGroup } from '@chakra-ui/react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import config from '@config';
import { useEOEContext } from '@store/EOEContext';

let lastCityClicked = '';
/**
 *
 */
const LocationCard = ({ sectionContent, region, lang, setIsCityClicked }) => {
  const { city, setCity, isIeDone, setCityName, setSeatCategory } =
    useEOEContext();

  const gtmClick = city => {
    // console.log('gtmClick', lastCityClicked, 'id', city?.id);
    if (typeof window !== 'undefined' && lastCityClicked !== city?.id) {
      lastCityClicked = city.id;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'EoE_City_Selected',
        IE_status: isIeDone,
        city: city?.Category,
      });
      // window.dataLayer.push({ ecommerce: null });
      // window.dataLayer.push({
      //   event: 'view_item',
      //   ecommerce: {
      //     currency: '',
      //     value: '',
      //     items: [
      //       {
      //         item_id: city?.id, // id of the program
      //         item_name: 'EoE', // Name of the program (Ex - EoE)
      //         affiliation: '',
      //         coupon: '',
      //         discount: '',
      //         index: '',
      //         item_brand: isIeDone ? 'Yes' : 'No', //IE Status <Yes/No>
      //         item_category: ieLang, //IE Lang (User selected IE Language Ex- MR,EN,HI)
      //         item_category2: '',
      //         item_category3: '',
      //         item_category4: 'City_Section',
      //         item_category5: '',
      //         item_list_id: '',
      //         item_list_name: '',
      //         item_variant: '',
      //         location_id: city?.Category,
      //         price: '',
      //         quantity: '',
      //       },
      //     ],
      //   },
      // });
    }
  };

  const cardStyle = {
    Open: {
      // boxShadow: '0 0 2px #979797',
      background: '#FFFFFF',
    },
    Selected: {
      background: '#F5F0E5',
      border: '2px solid #CF4520',
    },
    Full: {
      outline: 'none',
      boxShadow: 'none',
      background: '#F5F0E5',
    },
  };

  return (
    <Box
      display="flex"
      gap={{ base: '8px', md: '15px' }}
      justifyContent="space-between"
      maxW="1010px"
      mx="auto"
      px={{ base: '0px', md: '30px' }}
      w="full"
      flexWrap="wrap"
    >
      <RadioGroup
        onChange={setCity}
        value={city}
        w="100%"
        display="flex"
        flexDir={{ base: 'row', md: 'row' }}
        justifyContent="center"
        gridGap="2%"
        gap="2%"
        flexWrap="wrap"
      >
        {sectionContent?._modelApiKey === 'json_table' &&
          sectionContent.data?.map(itemList => (
            <Box
              as="label"
              border="1px solid #979797"
              borderRadius="10px"
              boxSizing="border-box"
              style={
                (config.ENV_NAME === 'production'
                  ? itemList?.id
                  : itemList?.uatId) === city
                  ? cardStyle.Selected
                  : cardStyle.Open
              }
              _hover={{
                boxShadow:
                  '3.06087px 18.7518px 41px rgba(34, 30, 2, 0.08), 1.98389px 12.154px 24.0116px rgba(34, 30, 2, 0.0607407), 1.179px 7.22293px 13.0593px rgba(34, 30, 2, 0.0485926), 0.612173px 3.75037px 6.6625px rgba(34, 30, 2, 0.04), 0.249404px 1.52793px 3.34074px rgba(34, 30, 2, 0.0314074), 0.0566827px 0.347256px 1.61343px rgba(34, 30, 2, 0.0192593)',
              }}
              display="flex"
              flexDir="column"
              p={{ base: '10px', md: '10px 25px 16px' }}
              w={{ base: '30%', md: '30%' }}
              maxW="279px"
              mb={{ base: '8px', md: '20px' }}
              alignItems={{ base: 'center', md: 'flex-start' }}
              size="lg"
              justifyContent="space-between"
              onClick={() => {
                setIsCityClicked(true);
                gtmClick(itemList);
                setCityName(itemList.Category);
                setSeatCategory(itemList.Category);
              }}
              key={
                config.ENV_NAME === 'production'
                  ? itemList?.id
                  : itemList?.uatId
              }
              cursor="pointer"
            >
              <Box
                display="flex"
                gap="10px"
                pb="10px"
                justifyContent={{ base: 'center', md: 'space-between' }}
                flexDir={{ base: 'column-reverse', md: 'row' }}
                alignItems="center"
                w="full"
              >
                <Box
                  fontFamily="'FedraSansStd-medium'"
                  fontSize={{ base: '14px', md: '20px' }}
                >
                  {itemList?.Category}
                </Box>{' '}
                <Radio
                  value={
                    config.ENV_NAME === 'production'
                      ? itemList?.id
                      : itemList?.uatId
                  }
                  isInvalid
                  bg="white"
                  border="1px solid"
                  _checked={{
                    background: '#CF4520',
                    border: '2px solid #fff',
                    outline: '4px solid #fff',
                    outlineOffset: '-5px',
                  }}
                />
              </Box>
              <Box
                bg="#E4DED4"
                px="10px"
                py="4px"
                fontFamily="'FedraSansStd-book'"
                width={{ base: '100%', md: 'fit-content' }}
                borderRadius="4px"
                textAlign={{ base: 'center', md: 'left' }}
              >
                {itemList?.date}
              </Box>
            </Box>
          ))}
      </RadioGroup>
    </Box>
  );
};

export default LocationCard;
